export enum BusinessStatus {
    ACTIVE = 'Active',
    CREATED = 'Created',
    REVIEW = 'Review',
    REJECTED = 'Rejected',
    SUSPENDED = 'Suspended',
    APPROVED = 'Approved',
    LIVE = 'Live',
    CLOSED = 'Closed'
}
